import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { clearAuthData } from '../helpers/authStorage';
import { useServicerStore } from '../store';

export default function useSignOut() {
  const setUserRole = useServicerStore((state) => state.setUserRole);

  const queryClient = useQueryClient();

  const navigate = useNavigate();

  return () => {
    clearAuthData();
    setUserRole(null);
    queryClient.clear();
    Sentry.setUser(null);
    navigate('/login');
  };
}
